var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 0C4.6498 0 3.04022 0.677294 1.85346 1.88288C0.666711 3.08848 0 4.72361 0 6.42857L0 9.28571C0 10.4686 0.945 11.4286 2.10938 11.4286H37.2656C37.8251 11.4286 38.3616 11.6543 38.7572 12.0562C39.1528 12.4581 39.375 13.0031 39.375 13.5714C39.375 14.1397 39.1528 14.6848 38.7572 15.0867C38.3616 15.4885 37.8251 15.7143 37.2656 15.7143H2.10938C1.54993 15.7143 1.01341 15.9401 0.617822 16.3419C0.222237 16.7438 0 17.2888 0 17.8571L0 33.5714C0 35.2764 0.666711 36.9115 1.85346 38.1171C3.04022 39.3227 4.6498 40 6.32812 40H38.6719C40.3502 40 41.9598 39.3227 43.1465 38.1171C44.3333 36.9115 45 35.2764 45 33.5714V12.1429C45 10.4379 44.3333 8.80276 43.1465 7.59717C41.9598 6.39158 40.3502 5.71429 38.6719 5.71429H27.7622C27.2029 5.71379 26.6668 5.48769 26.2716 5.08571L23.1188 1.88571C22.5314 1.28825 21.8338 0.814203 21.0661 0.490647C20.2983 0.167091 19.4753 0.000367832 18.6441 0H6.32812Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.c304aff32e83b97a05dadc5b7e371aa6.svg";
export { ForwardRef as ReactComponent };